import { PaginationCenterContainer } from '../styled-components.js'
import {
  ChevronLeftSmall,
  ChevronRightSmall,
  Collapse,
  Expand
} from '../../../../../atoms/icons/essentials/index.js'
import ButtonComponent from '../../../../../atoms/button/index.jsx'
import {
  buttonSizeOptions,
  buttonTypeOptions,
  buttonVariantOptions
} from '../../../../../atoms/button/constants.js'

export const PaginationCenter = ({
  pageNumber,
  totalPages,
  onPageChange,
  disabled = false
}) => {
  // Convert 0-indexed to 1-indexed for display
  const currentPage = pageNumber + 1

  // Handle page navigation
  const handlePageChange = (newPage) => {
    // Convert 1-indexed back to 0-indexed for API
    onPageChange(newPage - 1)
  }

  const FirstPageButton = () => {
    if (totalPages < 3) return null

    const isDisabled = disabled || currentPage === 1

    return (
      <ButtonComponent
        disabled={isDisabled}
        variant={buttonVariantOptions.GHOST}
        buttonType={buttonTypeOptions['ICON-ONLY']}
        size={buttonSizeOptions.SMALL}
        onClick={() => handlePageChange(1)}
      >
        <Collapse />
      </ButtonComponent>
    )
  }

  const LastPageButton = () => {
    if (totalPages < 3) return null

    const isDisabled = disabled || currentPage === totalPages

    return (
      <ButtonComponent
        disabled={isDisabled}
        variant={buttonVariantOptions.GHOST}
        buttonType={buttonTypeOptions['ICON-ONLY']}
        size={buttonSizeOptions.SMALL}
        onClick={() => handlePageChange(totalPages)}
      >
        <Expand />
      </ButtonComponent>
    )
  }

  const PreviousPage = () => {
    if (totalPages < 2) return null

    const isDisabled = disabled || currentPage === 1

    return (
      <ButtonComponent
        disabled={isDisabled}
        variant={buttonVariantOptions.GHOST}
        buttonType={buttonTypeOptions['ICON-ONLY']}
        size={buttonSizeOptions.SMALL}
        onClick={() => handlePageChange(currentPage - 1)}
      >
        <ChevronLeftSmall />
      </ButtonComponent>
    )
  }

  const NextPageButton = () => {
    if (totalPages < 2) return null

    const isDisabled = disabled || currentPage === totalPages

    return (
      <ButtonComponent
        disabled={isDisabled}
        variant={buttonVariantOptions.GHOST}
        buttonType={buttonTypeOptions['ICON-ONLY']}
        size={buttonSizeOptions.SMALL}
        onClick={() => handlePageChange(currentPage + 1)}
      >
        <ChevronRightSmall />
      </ButtonComponent>
    )
  }

  // Generate the array of page numbers to display
  const getPageNumbers = () => {
    // If 5 or fewer pages, show all pages
    if (totalPages <= 5) {
      return Array.from({ length: totalPages }, (_, i) => i + 1)
    }

    // Near the start (pages 1-3)
    if (currentPage <= 3) {
      return [1, 2, 3, 4, '...', totalPages]
    }

    // Near the end (last 3 pages)
    if (currentPage >= totalPages - 2) {
      return [
        1,
        '...',
        totalPages - 3,
        totalPages - 2,
        totalPages - 1,
        totalPages
      ]
    }

    // In the middle
    return [
      1,
      '...',
      currentPage - 1,
      currentPage,
      currentPage + 1,
      '...',
      totalPages
    ]
  }

  // Page number buttons
  const PageNumberButtons = () => {
    const pageNumbers = getPageNumbers()

    return (
      <>
        {pageNumbers.map((page, index) => {
          // If it's ellipsis, render it as text
          if (page === '...') {
            return (
              <ButtonComponent
                key={`page-${page}`}
                variant={buttonVariantOptions.GHOST}
                buttonType={buttonTypeOptions['ICON-ONLY']}
                size={buttonSizeOptions.SMALL}
                disabled={true}
              >
                {page}
              </ButtonComponent>
            )
          }

          const isSelected = currentPage === page

          return (
            <ButtonComponent
              key={`page-${page}`}
              variant={
                isSelected
                  ? buttonVariantOptions['SECONDARY-WHITE-FILL']
                  : buttonVariantOptions.GHOST
              }
              buttonType={buttonTypeOptions['ICON-ONLY']}
              size={buttonSizeOptions.SMALL}
              disabled={disabled}
              onClick={() => handlePageChange(page)}
            >
              {page}
            </ButtonComponent>
          )
        })}
      </>
    )
  }

  return (
    <PaginationCenterContainer>
      <FirstPageButton />
      <PreviousPage />
      <PageNumberButtons />
      <NextPageButton />
      <LastPageButton />
    </PaginationCenterContainer>
  )
}

export default PaginationCenter
